// src/utils/tracking.js

// Dán URL Web App bạn lấy được sau khi deploy Apps Script vào đây
const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbykUP5iZt7u2B3Oo-ltRZX0JsVrmzOtEylGbE02PFTP90HWDnHBzGeb8tlDu1pg18hE/exec";

/**
 * Gửi 1 event lên Google Sheet.
 * type: "visit" | "click"
 * extra: { itemName, url } (chỉ cần khi type = "click")
 *
 * Lưu ý: dùng mode "no-cors" vì Apps Script Web App không xử lý
 * preflight OPTIONS request đúng chuẩn CORS. Với no-cors, request
 * vẫn được gửi và Apps Script vẫn ghi được dữ liệu, chỉ là ở phía
 * client mình không đọc được response (không cần thiết ở đây).
 */
export const trackEvent = (type, extra = {}) => {
    try {
        // console.log("Tracking event:", type, extra);
        fetch(SCRIPT_URL, {
            method: "POST",
            mode: "no-cors",
            headers: {
                "Content-Type": "text/plain;charset=utf-8", // tránh trigger preflight
            },
            body: JSON.stringify({
                type,
                itemName: extra.itemName || "",
                url: extra.url || "",
                referrer: document.referrer,
                userAgent: navigator.userAgent,
            }),
        });
    } catch (err) {
        // console.error("Tracking error:", err);
    }
};

/**
 * Ghi nhận 1 lượt visit duy nhất mỗi phiên (session), tránh việc
 * người dùng F5 liên tục làm tăng ảo số liệu.
 */
export const trackVisitOnce = () => {
    const key = "hasTrackedVisit";
    if (!sessionStorage.getItem(key)) {
        trackEvent("visit");
        sessionStorage.setItem(key, "true");
    }
};